import { omit } from "lodash";

import { ITransaction } from "interfaces/entities/transaction";

import { CRUDAction, RequestAction } from "../actions";
// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { IEntityCollectionState } from "../reducer";

import { TRANSACTION, TransactionAction } from "./actions";
import {
  IMergeTransactionSuccessPayload,
  ITransactionDeleteAttachmentSuccessPayload,
  ITransactionFetchFailurePayload,
  ITransactionFetchSuccessPayload,
  ITransactionUploadAttachmentSuccessPayload,
} from "./interfaces";

const initialState = {};

export const transactionsReducer = (
  state: IEntityCollectionState<ITransaction> = initialState,
  action: TransactionAction
): IEntityCollectionState<ITransaction> => {
  switch (action.type) {
    case TRANSACTION[CRUDAction.FETCH_SINGLE][RequestAction.SUCCESS]:
    case TRANSACTION[CRUDAction.CREATE][RequestAction.SUCCESS]: {
      const { transaction } = action.payload as ITransactionFetchSuccessPayload;

      return {
        ...state,
        [transaction.id]: transaction,
      };
    }
    case TRANSACTION.DELETE_ATTACHMENT[RequestAction.SUCCESS]: {
      const { transactionID, attachmentID } = action.payload as ITransactionDeleteAttachmentSuccessPayload;
      const newAttachments = state[transactionID].attachments.filter(attachment => attachment.id !== attachmentID);

      return {
        ...state,
        [transactionID]: { ...state[transactionID], attachments: newAttachments },
      };
    }
    case TRANSACTION.UPLOAD_ATTACHMENT[RequestAction.SUCCESS]: {
      const { attachment, transactionID } = action.payload as ITransactionUploadAttachmentSuccessPayload;
      if (!state[transactionID]) {
        return state;
      }

      return {
        ...state,
        [transactionID]: {
          ...state[transactionID],
          attachments: [...state[transactionID].attachments, attachment],
        },
      };
    }
    case TRANSACTION.MERGE_TRANSACTION[RequestAction.SUCCESS]: {
      const { attachments, transactionID } = action.payload as IMergeTransactionSuccessPayload;

      return {
        ...state,
        [transactionID]: {
          ...state[transactionID],
          attachments: [...state[transactionID].attachments, ...attachments],
        },
      };
    }
    case TRANSACTION[CRUDAction.FETCH_SINGLE][RequestAction.FAILURE]: {
      const { id } = action.payload as ITransactionFetchFailurePayload;

      const newState = omit(state, id);
      return newState;
    }
    default:
      return state;
  }
};
